import init from '../../common/base/init';

init(() => {
  const beforePrint = () => {
    document.querySelector('html').classList.add('html--print');
  };

  const afterPrint = () => {
    document.querySelector('html').classList.remove('html--print');
    window.dispatchEvent(new CustomEvent('resize'));
  };

  // safari
  const mediaQueryList = window.matchMedia('print');
  mediaQueryList.addListener(function(mql) {
    mql.matches ? beforePrint() : afterPrint();
  });

  // the rest
  window.onbeforeprint = beforePrint;
  window.onafterprint = afterPrint;
});
